import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { FavoriteDTO } from 'tekkeys-common';

export interface FavoritesState extends EntityState<FavoriteDTO> {
  errorStatus?: number;
}

export const favoritesAdapter: EntityAdapter<FavoriteDTO> = createEntityAdapter<FavoriteDTO>();
